<template>
  <div class="p-integrations">
    <div class="p-integrations-status__loader" v-if="loading">
      <VLoadingSpinner size="large" />
    </div>
    <template v-if="integrationsLoaded">
      <p>{{ $t('companySettings.integrations.description') }}</p>
      <VGrid>
        <SlackCardScreen
          slot="gridItem"
          type="4"
        />
        <div
          v-for="integration in integrations"
          :key="integration.slug"
          slot="gridItem"
          type="4">
          <VIntegrationOverview
            :integration="integration"
            @loadingStateChanged="setLoading"
            @openManageIntegrationModal="openManageIntegrationModal"
          />
        </div>
        <div v-for="integration in externalIntegrations" :key="integration.slug" slot="gridItem" type="4">
          <VExternalIntegrationOverview
            :integration="integration"
          />
        </div>
      </VGrid>

      <ManageDropbox
        v-if="integrations.dropbox"
        :integration="integrations.dropbox"
        :show="isIntegrationSelected('dropbox')"
        :showAuthSuccess="authSuccess"
        @close="closeManageIntegrationModal"
        @disconnect="openConfirmDisconnectModal"
        @loadingStateChanged="setLoading"
      />

      <ManageCapsule
        v-if="integrations.capsule"
        :integration="integrations.capsule"
        :show="isIntegrationSelected('capsule')"
        :showAuthSuccess="authSuccess"
        @close="closeManageIntegrationModal"
        @loadingStateChanged="setLoading"
      />

      <ManageGoogleDrive
        v-if="integrations.googledrive"
        :integration="integrations.googledrive"
        :show="isIntegrationSelected('googledrive')"
        :showAuthSuccess="authSuccess"
        @disconnect="openConfirmDisconnectModal"
        @close="closeManageIntegrationModal"
        @loadingStateChanged="setLoading"
      />
    </template>
    <ConfirmIntegrationDisconnectModal
      :show="showConfirmIntegrationDisconnectModal"
      @close="showConfirmIntegrationDisconnectModal = false;"
      @loadingStateChanged="setLoading"
      :text="disconnectText"
      :integration="disconnectIntegration"
    />
  </div>
</template>

<script>
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import VIntegrationOverview from '@/views/components/IntegrationOverview.vue';
import ManageDropbox from '@/views/modals/integrations/ManageDropbox.vue';
import ManageCapsule from '@/views/modals/integrations/ManageCapsule.vue';
import ManageGoogleDrive from '@/views/modals/integrations/ManageGoogleDrive.vue';
import VExternalIntegrationOverview from '@/views/components/ExternalIntegrationOverview.vue';
import ConfirmIntegrationDisconnectModal from '@/views/modals/integrations/ConfirmIntegrationDisconnectModal.vue';
import { SlackCardScreen } from '@/components/screens/integrations/SlackCardScreen';

export default {
  name: 'Integrations-page',
  components: {
    ConfirmIntegrationDisconnectModal,
    VExternalIntegrationOverview,
    VLoadingSpinner,
    VGrid,
    VIntegrationOverview,
    ManageDropbox,
    ManageCapsule,
    ManageGoogleDrive,
    SlackCardScreen,
  },
  data() {
    return {
      showConfirmIntegrationDisconnectModal: false,
      disconnectIntegration: null,
      disconnectText: null,
      componentLoading: false,
      exchangingToken: false,
      gettingIntegrations: true,
      authSuccess: false,
      showManageIntegrationModal: false,
    };
  },
  mounted() {
    this.$store.dispatch('integrations/GET_INTEGRATIONS').then(() => {
      this.gettingIntegrations = false;
    });

    // If code parameter is present attempt token exchange
    const { code } = this.$route.query;
    const { slug } = this.$route.params;
    if (code && slug) {
      this.exchangingToken = true;
      this.$store.dispatch('integrations/EXCHANGE_INSTANCE_TOKEN', { slug, code }).then(() => {
        this.authSuccess = true;
        this.$router.replace({ name: 'Integrations' });
        this.openManageIntegrationModal(slug);
      }).finally(() => {
        this.exchangingToken = false;
      });
    }
  },
  computed: {
    ...mapGetters({
      integrations: 'integrations/integrations',
      externalIntegrations: 'integrations/externalIntegrations',
    }),
    integrationsLoaded() {
      return !isEmpty(this.integrations);
    },
    loading() {
      return this.gettingIntegrations || this.exchangingToken || this.componentLoading;
    },

  },
  methods: {
    openConfirmDisconnectModal(text, integration) {
      this.disconnectText = text;
      this.disconnectIntegration = integration;
      this.showConfirmIntegrationDisconnectModal = true;
    },
    setLoading(state) {
      this.componentLoading = state;
    },
    openManageIntegrationModal(integration) {
      this.showManageIntegrationModal = integration;
    },
    isIntegrationSelected(integration) {
      return this.showManageIntegrationModal === integration;
    },
    closeManageIntegrationModal() {
      this.showManageIntegrationModal = false;
      this.authSuccess = false;
    },
  },
};
</script>
